import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { VipDiscountsReceivedComponent } from './pages/vip-discounts-received/vip-discounts-received.component';

const routes: Routes = [
  {
    path: '',
    component: VipDiscountsReceivedComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VipDiscountsBuyingRoutingModule {}
